import React from 'react'
import { media } from '../../server'
import { useStateContext } from '../../context/ContextProvider'
import Button from '../layout/Button';
import {Link} from "react-router-dom"
import { IoArrowBackOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next'
function VideoCard({video,category}) {
    const {currentDir} = useStateContext();
    const { t } = useTranslation();
    const truncateText = (text, wordLimit) => {
        const words = text.split(' ');
        if (words.length > wordLimit) {
          return words.slice(0, wordLimit).join(' ') + '...';
        }
        return text;
      };
  
  return (
    <div>
    <div className='relative flex min-h-[20rem]  rounded-2xl mx-auto gap-5 flex-col items-start p-4 bg-n-1 dark:bg-back-darktertiary shadow-lg border border-gray-300 dark:border-gray-800 dark:hover:border-color-7 hover:border-color-1'>
  
        <img src={`${media}${video?.Image}`}  className=" w-full rounded-xl  object-cover" />

        <div className="">
        <p className="text-gray-600 text-sm font-kufi dark:text-gray-300">{video?.date}</p>
          <h4 className="font-semibold font-kufi text-lg text-gray-800 dark:text-gray-100">{currentDir ==="ltr" ?  truncateText(video.titleEn, 4) 
          : truncateText(video.titleAr,4)}</h4>
         
   
      </div>
    
      <Link
          to={
           `/VedioDetails`
          }state={{VideoData:video,
        category:category}}
          onClick={() => {
          
            window.scrollTo(0, 0); 
        
          }}
        >
      <Button text={t('To watch')} Transform={true} nonBackground={true} textStyle={"font-kufi text-sm text-simeBold"}  
      textColor={"text-color-1"} icon={<IoArrowBackOutline />}/>
      </Link>
     </div>
 
  </div>
  )
}

export default VideoCard